import { formatUserOperationRequest, } from 'viem/account-abstraction';
import { toHex } from 'viem';
export function createPaymasterRequest(args) {
    const { userOp, functionHashForPaymasterProxy, rootKeyAddress, townId, maxFeePerGasOverride, maxPriorityFeePerGasOverride, } = args;
    if (!functionHashForPaymasterProxy) {
        throw new Error('functionHashForPaymasterProxy is required');
    }
    if (!userOp.callData || !userOp.signature) {
        throw new Error('Invalid user operation paymasterProxyMiddleware');
    }
    if (!userOp.sender)
        userOp.sender = '0xempty';
    if (!userOp.callGasLimit)
        userOp.callGasLimit = 0n;
    if (!userOp.verificationGasLimit)
        userOp.verificationGasLimit = 0n;
    if (!userOp.preVerificationGas)
        userOp.preVerificationGas = 0n;
    if (!userOp.maxFeePerGas)
        userOp.maxFeePerGas = 0n;
    if (!userOp.maxPriorityFeePerGas)
        userOp.maxPriorityFeePerGas = 0n;
    if (!userOp.nonce)
        userOp.nonce = 0n;
    const rpcRequest = {
        ...formatUserOperationRequest(userOp),
        functionHash: functionHashForPaymasterProxy,
        rootKeyAddress,
        townId,
        gasOverrides: {
            maxFeePerGas: maxFeePerGasOverride ? toHex(maxFeePerGasOverride) : undefined,
            maxPriorityFeePerGas: maxPriorityFeePerGasOverride
                ? toHex(maxPriorityFeePerGasOverride)
                : undefined,
        },
    };
    return rpcRequest;
}
